export default {
  HomePage: {
    title: 'Estimator24 — Evaluarea imobilelor cu inteligență artificială',
    description: 'Evaluarea apartamentelor, caselor și complexelor rezidențiale din Europa și Turcia cu ajutorul AI.'
  },
  AboutPage: {
    title: 'Despre Estimator24',
    description: 'Platformă pentru evaluarea, analiza și investițiile în imobiliare.'
  },
  PropertyList: {
    title: 'Catalogul imobilelor — Estimator24',
    description: 'Toate apartamentele, vilele și casele cu evaluare AI. Căutare după țară, regiune și dezvoltator.'
  },
  PropertyDetail: {
    title: '{title} — {city} — Estimator24',
    description: 'Informații detaliate și evaluare AI a imobilului în {city}.'
  },
  DeveloperList: {
    title: 'Dezvoltatori — Estimator24',
    description: 'Catalog al dezvoltatorilor imobiliari și companiilor de construcții.'
  },
  DeveloperDetail: {
    title: '{developer} — Dezvoltator — Estimator24',
    description: 'Proiectele și complexele rezidențiale ale dezvoltatorului {developer}.'
  },
  ResidentialComplexShow: {
    title: '{title} — Complex rezidențial — Estimator24',
    description: 'Descriere, prețuri și planuri pentru complexul {title}.'
  },
  AgencyList: {
    title: 'Agenții imobiliare — Estimator24',
    description: 'Catalogul agențiilor imobiliare și al ofertelor acestora.'
  },
  AgencyDetail: {
    title: '{agency} — Agenție imobiliară — Estimator24',
    description: 'Proprietăți și informații de contact pentru agenția {agency}.'
  },
  NewsList: {
    title: 'Știri imobiliare — Estimator24',
    description: 'Statistici, analize și tendințe ale pieței imobiliare.'
  },
  NewsDetail: {
    title: '{title} — Știri Estimator24',
    description: '{excerpt}'
  },
  StatisticPage: {
    title: 'Statistici imobiliare — Estimator24',
    description: 'Indicatori de preț, vânzări și construcții în timp real.'
  },
  PrivacyPolicy: {
    title: 'Politica de confidențialitate — Estimator24',
    description: 'Termenii de prelucrare a datelor și politica de confidențialitate.'
  }
}
